/**
 * @Description 商圈详情-本品牌门店列表
 */

import { FC, useEffect, useRef, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Pagination from '@/common/components/Data/V2Pagination';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { getShopList, getShopListShare } from '@/common/api/expandStore/shop';
import StoreItem from './StoreItem';
import styles from './index.module.less';
import ShopDetailDrawer from '@/views/expandstore/pages/shopDetail/Drawer';

export interface StoreListProps {
  detail?: any;
  viewDetail?: boolean;
  isShare?: boolean; // 分享页场景
  tenantId?: number; // 分享页场景
  employeeId?: number; // 分享页场景
  [p:string]: any;
}

const StoreList: FC<StoreListProps> = ({
  detail,
  viewDetail,
  isShare,
  tenantId,
  employeeId,
  shareParams,
}) => {
  const detailRef: any = useRef();
  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(1); // 当前页数
  const [pageSize, setPageSize] = useState<any>(3); // 当前页长
  const [list, setList] = useState<any>([]); // 机会点数据
  const [loading, setLoading] = useState<any>(false); // 当前页数

  useEffect(() => {
    detail.id && methods.loadData({});
  }, [detail]);

  const methods = useMethods({
    // 分页相关
    handlePageChange: (value: any, pageSize: number) => {
      setCurrentPage(value);
      setPageSize(pageSize);
      methods.loadData({ page: value, pageSize: pageSize });
    },

    loadData: async (params) => {
      const _params: any = {
        page: params?.page || currentPage,
        size: params?.pageSize || pageSize,
        modelClusterId: detail.id,
        ...(isShare ? { tenantId, userId: employeeId } : {}),
      };

      setLoading(true);
      const targetFetch = isShare && (!shareParams?.token) ? getShopListShare : getShopList;
      const { objectList, totalNum } = await targetFetch(_params).finally(() => setLoading(false));
      setTotalNum(totalNum);
      setList(isArray(objectList) ? objectList : []);
    },
    onClick(val: any) {
      if (viewDetail) {
        detailRef.current?.init?.(val.id);
      }
    }
  });

  return (
    <>
      {totalNum ? <div className={styles.storeList}>
        <V2Title divider type='H2' text={`本品牌门店(${totalNum})`}/>
        {list?.map(item => (
          <StoreItem
            key={item.id}
            detail={item}
            onClick={methods.onClick}
            className={viewDetail ? 'pointer' : ''}
          />
        ))}
        {totalNum > pageSize
          ? <V2Pagination
            simple={true}
            disabled={loading}
            current={currentPage}
            total={totalNum}
            onChange={methods.handlePageChange}
            pageSize={pageSize}
          /> : '' }
      </div> : <></>}
      <ShopDetailDrawer ref={detailRef} reload={methods.loadData} />
    </>
  );
};

export default StoreList;
